/* eslint-disable */
import { Axios } from "../axios";

interface IUploadAdditionalDocs {
  body: FormData;
  code: string;
  purpose: string;
}

export const studentPassUniFeesUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
        "Access-Control-Allow-Origin": "true",
        "Content-Type": "application/json",
      },
    }
  );
};

export const eduLivingExpensesUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};
export const studentVisaUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const familyMaintenanceUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Relationship-Proof&purpose=Family-Maintenance`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};
export const bankStatementUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Bank-Statement&purpose=Family-Maintenance`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const beneficiaryIdUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Bene-Id&purpose=Family-Maintenance`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const personalGiftPassUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Recepient-Passport&purpose=Personal-Gift-Donation`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const personalGiftLicenseUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Driving-Licence-SSN-number&purpose=Personal-Gift-Donation`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const loanUniFeesUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Loan-Sanction-letter&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const loanLivingExpenseUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Loan-Sanction-letter&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const getTransactionSummary = async (purposeCode: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/user/getTransactionSummary", purposeCode, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const universityOfferLetterUniFeesUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=University-Offer-Letter&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const uploadStudentPassportBackUni = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport-Back&purpose=Overseas-Education-University-Fees`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const uploadStudentPassportBackLivingExp = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Student-Passport-Back&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const rentAgreementInvoiceUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Rent-Agreement-Invoice&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const universityOfferLetterLivingExpenseUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=University-Offer-Letter&purpose=Overseas-Education-Living-Expenses`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const giftDeclarationUpload = async (body: FormData) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Gift-Declaration&purpose=Personal-Gift-Donation`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const airTicketUpload = async (body: FormData, purposeCode: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Air-Ticket-Copy&purpose=${purposeCode}`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const visaUpload = async (body: FormData, purposeCode: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(
    `/remit/user/${currentUser.vendor_key}/lead/upload/doc?docType=Visa&purpose=${purposeCode}`,
    body,
    {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    }
  );
};

export const getVendorCode = async () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.get(`/remit/user/${currentUser.vendor_key}/linkedVendorCode`, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};

export const i20Upload = async (body: FormData, params: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  return await Axios.post(`/remit/user/${currentUser.vendor_key}/lead/upload/${params}`, body, {
    headers: {
      Authorization: `${currentUser.idToken}`,
    },
  });
};
